import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./recipient-list.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./recipient-list.component.scss?ngResource";
import { ChangeDetectorRef, Component, forwardRef, Input } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { AddRecipientModalComponent } from "../shared/modal-components/add-recipient-modal/add-recipient-modal.component";
import { AlertType } from "../../../models/alert";
import { AppControllerService } from "../../../../app-controller.service";
import { FormBuilder, NG_VALIDATORS, NG_VALUE_ACCESSOR } from "@angular/forms";
import { RecipientListConstant, RecipientsHeadingLookup } from "./recipient-list.constant";
import { EditRecipientModalComponent } from "../shared/modal-components/edit-recipient-modal/edit-recipient-modal.component";
import RecipientUtils from "../../../utils/recipient-utils";
import { SharedConstants } from "../../../constants/shared.constants";
import { ConfirmDeleteModalComponent } from "../shared/modal-components/confirm-delete-modal/confirm-delete-modal.component";
import { UserInformationService } from "../../../services/user/user-information.service";
let RecipientListComponent = class RecipientListComponent {
    appControllerService;
    formBuilder;
    userInformationService;
    changeDetectorRef;
    modalService;
    stepMetaRecipientGroups = [];
    showRecipientsGroupsDropdown = true;
    disableAddRecipientButton = false // show or hide the add recipient button
    ;
    disableEditRecipientButton = false // show or hide the edit recipient button
    ;
    disableDeleteRecipientButton = false // show or hide the delete recipient button
    ;
    showRecipientTypeColumn = true;
    hideFilter = false;
    configurableLabel = "Recipient";
    jobId;
    hideAddButton = false;
    hideEditButton = false;
    hideDeleteButton = false;
    disableEditing = false;
    showAllFormFields = true;
    formName;
    tableDataSource = new BehaviorSubject([]);
    tableMapper;
    tableSelection = [];
    recipientListForm;
    groupsOptions = [];
    modalBodyOptions = RecipientListConstant.modalBodyOptions;
    i;
    showDefaultCommunicationMethods = true;
    // Labels
    addBtnLabel = RecipientListConstant.addBtnLabel;
    editBtnLabel = RecipientListConstant.editBtnLabel;
    deleteBtnLabel = RecipientListConstant.deleteBtnLabel;
    // error messages
    metadataPropertyNotSetErrMsg = RecipientListConstant.metadataPropertyNotSetErrMsg;
    // metadata properties
    moduleId;
    componentName = "recipient list";
    constructor(appControllerService, formBuilder, userInformationService, changeDetectorRef, modalService) {
        this.appControllerService = appControllerService;
        this.formBuilder = formBuilder;
        this.userInformationService = userInformationService;
        this.changeDetectorRef = changeDetectorRef;
        this.modalService = modalService;
        this.moduleId = this.appControllerService.selectedModuleID ? Number(this.appControllerService.selectedModuleID) : null;
    }
    get value() {
        return this.recipientListForm.value;
    }
    set value(recipients) {
        const newRecipients = [];
        if (recipients && recipients.length > 0) {
            recipients.forEach(recipient => {
                // builds the group objects
                recipient.groups = this.buildRecipientGroupsArray(recipient);
                newRecipients.push(recipient);
            });
        }
        else {
            this.tableDataSource.next([]);
        }
        if (newRecipients.length > 0) {
            this.tableSelection = [];
            this.tableDataSource.next([...newRecipients]);
        }
        this.onChange(newRecipients);
        this.onTouched();
        this.changeDetectorRef.detectChanges();
    }
    onChange = () => {
    };
    onTouched = () => {
    };
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    ngOnInit() {
        this.initialiseForm();
        this.initializeColumnToObjectMapping();
        this.configureComponentOnInit();
    }
    arrayReturned(recipients) {
        this.tableSelection = recipients;
    }
    writeValue(recipients) {
        if (recipients) {
            this.value = recipients;
        }
        if (recipients === null) {
            this.recipientListForm.reset();
            this.tableDataSource.next([]);
        }
    }
    setDisabledState(disabled) {
        if (disabled) {
            this.recipientListForm.disable();
        }
        else {
            this.recipientListForm.enable();
        }
    }
    validate(_) {
        return this.recipientListForm.valid ? null : { formName: { valid: false } };
    }
    onAddBtnClicked() {
        const modalRef = this.modalService.open(AddRecipientModalComponent, this.modalBodyOptions);
        modalRef.componentInstance.dialogTitle = this.configurableLabel ? `Add new ${this.configurableLabel?.toLowerCase()}` : `Add new recipient`;
        modalRef.componentInstance.jobId = +this.jobId;
        modalRef.componentInstance.moduleId = +this.moduleId;
        modalRef.componentInstance.groupsFromMetadata = this.stepMetaRecipientGroups;
        modalRef.componentInstance.groupsOptions = this.groupsOptions;
        modalRef.componentInstance.showRecipientsGroupsDropdown = this.showRecipientsGroupsDropdown;
        modalRef.componentInstance.showDefaultCommunicationMethod = this.showDefaultCommunicationMethods;
        modalRef.result.then((newRecipient) => {
            if (newRecipient) {
                const recipientsAlreadyInTheTable = this.tableDataSource.value;
                const recipient = this.generateTempId(newRecipient);
                if (recipientsAlreadyInTheTable && recipientsAlreadyInTheTable.length > 0) {
                    recipientsAlreadyInTheTable.push(recipient);
                    this.value = recipientsAlreadyInTheTable;
                }
                else {
                    this.value = [recipient];
                }
            }
        });
    }
    onEditBtnClicked() {
        if (this.tableSelection.length === 0) {
            this.appControllerService.showMessage("Please select a recipient to edit from the table", AlertType.Warning); // put in constant file
            return;
        }
        if (this.tableSelection.length > 1) {
            this.appControllerService.showMessage("Please select only 1 recipient to edit from the table", AlertType.Warning); // put in constant file
            return;
        }
        const originalRecipient = Object.assign({}, this.tableSelection[0]);
        let selectedRecipientGroups = null;
        if (this.tableSelection[0].groupsStringArray)
            selectedRecipientGroups = this.tableSelection[0].groupsStringArray.map((group) => {
                return group;
            });
        const modalRef = this.modalService.open(EditRecipientModalComponent, this.modalBodyOptions);
        modalRef.componentInstance.dialogTitle = this.configurableLabel ? `Edit ${this.configurableLabel?.toLowerCase()}` : `Edit recipient`;
        modalRef.componentInstance.jobId = +this.jobId;
        modalRef.componentInstance.moduleId = +this.moduleId;
        modalRef.componentInstance.groupsFromMetadata = this.stepMetaRecipientGroups;
        modalRef.componentInstance.groupsOptions = this.groupsOptions;
        modalRef.componentInstance.recipientToEdit = originalRecipient;
        modalRef.componentInstance.selectedRecipientGroups = selectedRecipientGroups;
        modalRef.componentInstance.showDefaultCommunicationMethods = this.showDefaultCommunicationMethods;
        if (this.stepMetaRecipientGroups.length > 1) {
            modalRef.componentInstance.showRecipientGroupsDropdown = true;
        }
        else {
            modalRef.componentInstance.showRecipientGroupsDropdown = false;
        }
        modalRef.result.then((editedRecipient) => {
            if (editedRecipient) {
                const recipientsAlreadyInTheTable = this.tableDataSource.value;
                const ItemIndex = recipientsAlreadyInTheTable.findIndex(b => b.id === editedRecipient.id);
                recipientsAlreadyInTheTable[ItemIndex] = editedRecipient;
                this.value = recipientsAlreadyInTheTable;
                this.tableSelection = [];
            }
        });
    }
    onDeleteBtnClicked() {
        if (this.tableSelection.length > 0) {
            const modalRef = this.modalService.open(ConfirmDeleteModalComponent, this.modalBodyOptions);
            modalRef.componentInstance.label = this.configurableLabel ? `${this.configurableLabel?.toLowerCase()}` : "recipient";
            modalRef.result.then((deleteRecipients) => {
                if (deleteRecipients) {
                    const recipientsAlreadyInTheTable = this.tableDataSource.value;
                    const recipientsToBeDeleted = this.tableSelection;
                    for (let i = 0, len = recipientsToBeDeleted.length; i < len; i++) {
                        const ItemIndex = recipientsAlreadyInTheTable.findIndex(b => b.id === recipientsToBeDeleted[i].id);
                        recipientsAlreadyInTheTable.splice(ItemIndex, 1);
                    }
                    this.value = recipientsAlreadyInTheTable;
                    this.tableSelection = [];
                }
            });
        }
        else {
            this.appControllerService.showMessage(SharedConstants.NO_ITEM_SELECTED, AlertType.Warning);
        }
    }
    loadRecipient(recipient) {
        recipient.overrideGroup = true;
        recipient.appendToList = true;
        this.value = [recipient];
    }
    onRecipientTypeChanged(recipient, $event) {
        const selectedRecipient = recipient;
        const radioButtonValue = $event.target.value;
        selectedRecipient.emailField = radioButtonValue;
        this.value = [selectedRecipient];
    }
    loadAllRecipients(recipients) {
        this.value = recipients;
    }
    stepMetaPropertyNotSetErrMessage(propertyName) {
        // throws warning when one of the properties of the metadata is not set
        this.appControllerService.showMessage(`The ${propertyName} ${this.metadataPropertyNotSetErrMsg}`, AlertType.Warning);
    }
    initialiseForm() {
        this.recipientListForm = this.formBuilder.group({
            id: [],
            jobId: [],
            moduleId: [],
            name: [],
            surname: [],
            homePhone: [],
            telephone: [],
            cellphone: [],
            defaultCommunicationMethod: ["Email"],
            email: [],
            organisation: [],
            clientVatNumber: [],
            designation: [],
            professionalBody: [],
            professionalBodyRegNum: [],
            streetAddress: [],
            wardAreaName: [],
            streetSuburb: [],
            streetCity: [],
            streetProvince: [],
            streetCountry: [],
            streetCode: [],
            postalAddress: [],
            postalSuburb: [],
            postalCity: [],
            postalProvince: [],
            postalCountry: [],
            postalCode: [],
            groupsStringArray: [],
            groups: []
        });
    }
    initializeColumnToObjectMapping() {
        this.tableMapper = RecipientsHeadingLookup;
    }
    buildRecipientGroupsArray(recipient) {
        const recipientGroups = [];
        if (recipient.hasOwnProperty("groupsStringArray")) {
            recipient.groupsStringArray.forEach((groupNameString) => {
                recipientGroups.push({
                    groupName: groupNameString,
                    groupType: this.stepMetaRecipientGroups[0].groupType
                });
            });
        }
        if (recipient.groups && recipient.groups.length > 0 && !recipient.hasOwnProperty("groupsStringArray")) {
            recipient.groupsStringArray = recipient.groups.map((group) => {
                return group.groupName;
            });
            recipient.groupsStringArray.forEach((groupNameString) => {
                recipientGroups.push({
                    groupName: groupNameString,
                    groupType: this.stepMetaRecipientGroups[0].groupType
                });
            });
        }
        return recipientGroups;
    }
    configureComponentOnInit() {
        this.getGroupsFromMetadata();
        this.showOrHideAddRecipientButton();
        this.showOrHideEditRecipientButton();
        this.showOrHideDeleteRecipientButton();
        this.checkOrganisationSettings();
    }
    getGroupsFromMetadata() {
        // extract groups options for the dropdown
        if (this.stepMetaRecipientGroups.length === 0) {
            this.stepMetaPropertyNotSetErrMessage("stepMetaRecipientGroups");
            return;
        }
        // standardize the casing on the stepMetaRecipientGroups object
        this.stepMetaRecipientGroups = RecipientUtils.standardizeRecipientGroupsObject(this.stepMetaRecipientGroups);
        // get group options to be used on the add recipient and edit recipient modal windows
        this.groupsOptions = this.stepMetaRecipientGroups.map((group => {
            return group.groupName;
        }));
    }
    showOrHideAddRecipientButton() {
        if (this.disableAddRecipientButton) {
            this.hideAddButton = true;
        }
        else {
            this.hideAddButton = false;
        }
    }
    showOrHideEditRecipientButton() {
        if (this.disableEditRecipientButton) {
            this.hideEditButton = true;
        }
        else {
            this.hideEditButton = false;
        }
    }
    showOrHideDeleteRecipientButton() {
        if (this.disableDeleteRecipientButton) {
            this.hideDeleteButton = true;
        }
        else {
            this.hideDeleteButton = false;
        }
    }
    generateTempId(recipient) {
        let uuidValue = "";
        for (let k = 0; k < 32; k++) {
            // tslint:disable-next-line:no-bitwise
            const randomValue = Math.random() * 16 | 0;
            if (k === 8 || k === 12 || k === 16 || k === 20) {
                uuidValue += "-";
            }
            // tslint:disable-next-line:no-bitwise
            uuidValue += (k === 12 ? 4 : (k === 16 ? (randomValue & 3 | 8) : randomValue)).toString(16);
            recipient.id = uuidValue;
        }
        return recipient;
    }
    checkOrganisationSettings() {
        const organisationSettings = this.getOrganisationSettings();
        if (organisationSettings) {
            this.setDefaultCommunicationSettings(organisationSettings);
        }
        else {
            this.disableCommunicationMethods();
        }
    }
    getOrganisationSettings() {
        const organisationId = Number(this.appControllerService.selectedOrganisationId);
        const organisationInformation = this.userInformationService.getOrganisationInformation(organisationId);
        if (organisationInformation?.settings) {
            return organisationInformation.settings;
        }
        else {
            return null;
        }
    }
    setDefaultCommunicationSettings(organisationSettings) {
        this.showDefaultCommunicationMethods = false;
        const isSMSEnabledFromOrganisationSettings = organisationSettings.enableSms;
        const hasSMSProvider = (!(organisationSettings.smsProvider === "" || organisationSettings.smsProvider === "null" || organisationSettings.smsProvider === null));
        if (isSMSEnabledFromOrganisationSettings && hasSMSProvider) {
            this.showDefaultCommunicationMethods = true;
        }
        else {
            this.disableCommunicationMethods();
        }
        this.changeDetectorRef.detectChanges();
    }
    disableCommunicationMethods() {
        this.showDefaultCommunicationMethods = false;
    }
    static ctorParameters = () => [
        { type: AppControllerService },
        { type: FormBuilder },
        { type: UserInformationService },
        { type: ChangeDetectorRef },
        { type: NgbModal }
    ];
    static propDecorators = {
        stepMetaRecipientGroups: [{ type: Input }],
        showRecipientsGroupsDropdown: [{ type: Input }],
        disableAddRecipientButton: [{ type: Input }],
        disableEditRecipientButton: [{ type: Input }],
        disableDeleteRecipientButton: [{ type: Input }],
        showRecipientTypeColumn: [{ type: Input }],
        hideFilter: [{ type: Input }],
        configurableLabel: [{ type: Input }],
        jobId: [{ type: Input }]
    };
};
RecipientListComponent = __decorate([
    Component({
        selector: "app-recipient-list",
        template: __NG_CLI_RESOURCE__0,
        providers: [
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => RecipientListComponent),
                multi: true
            },
            {
                provide: NG_VALIDATORS,
                useExisting: forwardRef(() => RecipientListComponent),
                multi: true
            }
        ],
        styles: [__NG_CLI_RESOURCE__1]
    })
], RecipientListComponent);
export { RecipientListComponent };
